import axios from './http'

export function getSupplierList (token) {
  return axios({
    url: '/api/sale_punch/getSupplierList',
    headers: {
      'authorization': token
    },
    method: 'post'
  })
}

export function downloadExcel (token, data) {
  return axios({
    url: '/api/sale_punch/downloadExcel',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    method: 'post',
    data: data
  })
}
